import { Box, ButtonBase } from "@mui/material";

export interface ChoiceChipCotizadorOption {
  value: number;
  label: string;
}

interface Props {
  value: number;
  onChange: (value: number) => void;
  options: ChoiceChipCotizadorOption[];
  testId: string;
}

/**
 * Replica `.choice-chip` del cotizador en el diseño (con el override de Flux): botones de ancho
 * igual para elegir el plazo; el elegido va en `primary.base` con borde `primary.accent`.
 */
export const ChoiceChipsCotizador = ({ value, onChange, options, testId }: Props) => (
  <Box role="radiogroup" sx={{ display: "flex", gap: 1.25, flexWrap: "wrap" }}>
    {options.map((opt) => {
      const on = value === opt.value;
      return (
        <ButtonBase
          key={opt.value}
          role="radio"
          aria-checked={on}
          onClick={() => onChange(opt.value)}
          data-testid={`${testId}-${opt.value}`}
          sx={{
            flex: 1,
            minWidth: 84,
            p: "14px 18px",
            border: "1.5px solid",
            borderColor: on ? "primary.accent" : "divider",
            borderRadius: "8px",
            bgcolor: on ? "primary.base" : "background.paper",
            color: on ? "primary.dark" : "tokens.textPrimary",
            // `ButtonBase` no hereda la tipografía del theme (no hay `CssBaseline`): se toma explícita.
            fontFamily: (theme) => theme.typography.fontFamily,
            fontSize: 13.5,
            fontWeight: on ? 600 : 500,
            letterSpacing: "-0.005em",
            whiteSpace: "nowrap",
            transition: "border-color .18s ease, background-color .18s ease, color .18s ease",
            "&:hover": {
              borderColor: "primary.accent",
              bgcolor: "primary.base",
              // `--ld-blue-700` del diseño: el hover de la marca si lo define.
              color: (theme) => theme.palette.primary.hover ?? theme.palette.primary.main,
            },
          }}
        >
          {opt.label}
        </ButtonBase>
      );
    })}
  </Box>
);
